import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CheckoutOrderEffects } from './effects/checkout-order.effects';
import { CreateOrderEffects } from './effects/create-order.effects';
import { DeliveryDetailsEffects } from './effects/delivery-details.effects';
import { reducers } from './reducers';

@NgModule({
  imports: [
    StoreModule.forFeature('orderCheckout', reducers),
    EffectsModule.forFeature([
      CreateOrderEffects,
      CheckoutOrderEffects,
      DeliveryDetailsEffects,
    ]),
  ],
})
export class OrderCheckoutModule {}
